import React, { useEffect } from 'react';
import $ from 'jquery';

const TermsAndConditions = ({imgObject}) => {
    useEffect(()=>{
        $('[data-bg-img]').each(function() {
            $(this).css('background-image', 'url(' + $(this).data("bg-img") + ')');
        });
        $('[data-margin-top]').each(function() {
            $(this).css('margin-top', $(this).data("margin-top"));
        });
    },[]);
  return (
    <>
        <section className="inner-header divider parallax layer-overlay overlay-dark-5" data-bg-img={imgObject.bgImage}>
            <div className="container pt-70 pb-20">
                {/* <!-- Section Content --> */}
                <div className="section-content">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="title text-white">Terms & Conditions</h2>
                            <ol className="breadcrumb text-left text-black mt-10">
                                <li><a href="#">Home</a></li>
                                <li className="active text-gray-silver">Terms & Conditions</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="mission">
            <div className="container">
                <div className="section-title text-center">
                    <div className="row">
                        <div className="col-md-12 ">
                            <h2 className="text-uppercase line-bottom-double-line-centered mt-0">
                                <span className="text-theme-colored2">Terms & Conditions</span>
                            </h2>
                        </div>
                    </div>
                </div>

                <div className="section-content text-content">
                    <ol>

                        <li style={{ textAlign: "justify" }}><b>United Securities Limited</b></li>

                        <li style={{ textAlign: "justify" }}>
                            These Terms and Conditions (“Terms”) govern the use of financial securities and brokerage services provided by <b>United Securities Limited</b> (“the Company”) to its clients (“Client”). By opening an account or using our services, you acknowledge that you have read, understood, and agreed to be bound by these Terms.
                        </li>

                        <li style={{ textAlign: "justify" }}><b>1. Definitions</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}><b>1.1 Company</b></li>
                                <li style={{ textAlign: "justify" }}>
                                    Refers to United Securities Limited, a duly registered brokerage firm operating under the laws of Bangladesh.
                                </li>
                                <li style={{ textAlign: "justify" }}><b>1.2 Client</b></li>
                                <li style={{ textAlign: "justify" }}>
                                    Refers to any individual, institution, or entity that has engaged or intends to engage the services of the Company.
                                </li>
                            </ol>
                        </li>

                        <li style={{ textAlign: "justify" }}><b>2. Scope of Services</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}>
                                    <b>2.1</b> The Company provides brokerage and related financial services, including execution of securities transactions on behalf of the Client.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>2.2</b> The Company may also offer access to trading platforms, market data, research, and analytical tools.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>2.3</b> The Client acknowledges that all investment decisions are made at their own discretion unless otherwise agreed in writing.
                                </li>
                            </ol>
                        </li>

                        <li style={{ textAlign: "justify" }}><b>3. Investment Risk Disclosure</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}>
                                    <b>3.1</b> Investments in securities are subject to market risks, including price volatility, liquidity risk, and potential loss of capital.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>3.2</b> The Company does not guarantee any return, profit, or protection against losses.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>3.3</b> Past performance of any security or market trend does not indicate future results.
                                </li>
                            </ol>
                        </li>

                        <li style={{ textAlign: "justify" }}><b>4. Client Responsibilities</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}>
                                    <b>4.1</b> The Client shall comply with all applicable laws, rules, and regulations of Bangladesh, including those issued by regulatory authorities.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>4.2</b> The Client is responsible for providing accurate and complete information during account opening and throughout the relationship.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>4.3</b> The Client shall ensure the security and confidentiality of their account credentials and trading instructions.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>4.4</b> The Client agrees not to engage in any fraudulent, manipulative, or unlawful trading activities.
                                </li>
                            </ol>
                        </li>

                        <li style={{ textAlign: "justify" }}><b>5. Confidentiality & Data Protection</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}>
                                    <b>5.1</b> The Company shall maintain strict confidentiality of all Client information.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>5.2</b> Client data shall only be disclosed where required by law, regulatory authorities, or with the Client’s consent.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>5.3</b> The Company implements reasonable safeguards to protect Client data from unauthorized access or misuse.
                                </li>
                            </ol>
                        </li>

                        <li style={{ textAlign: "justify" }}><b>6. Fees & Charges</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}>
                                    <b>6.1</b> The Client agrees to pay all applicable brokerage fees, commissions, taxes, and other charges as agreed.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>6.2</b> The Company reserves the right to revise fees and charges with prior notice to the Client.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>6.3</b> All charges shall be clearly communicated and reflected in account statements or transaction confirmations.
                                </li>
                            </ol>
                        </li>

                        <li style={{ textAlign: "justify" }}><b>7. Compliance & Regulatory Obligations</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}>
                                    <b>7.1</b> Both the Company and the Client shall comply with all applicable laws, regulations, and directives issued by relevant authorities in Bangladesh.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>7.2</b> The Company reserves the right to refuse or cancel any transaction that may violate regulatory requirements.
                                </li>
                            </ol>
                        </li>

                        <li style={{ textAlign: "justify" }}><b>8. Reporting & Communication</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}>
                                    <b>8.1</b> The Company shall provide periodic statements, trade confirmations, and updates to the Client.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>8.2</b> Communication may be made through electronic means, including email, SMS, or online platforms.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>8.3</b> The Client is responsible for reviewing all communications and notifying the Company of discrepancies promptly.
                                </li>
                            </ol>
                        </li>

                        <li style={{ textAlign: "justify" }}><b>9. Termination of Services</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}>
                                    <b>9.1</b> Either party may terminate the service relationship in accordance with the terms outlined in the account opening agreement.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>9.2</b> The Company may suspend or terminate services in case of regulatory requirements, breach of Terms, or suspicious activity.
                                </li>
                            </ol>
                        </li>

                        <li style={{ textAlign: "justify" }}><b>10. Third-Party Services</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}>
                                    <b>10.1</b> The Company may integrate or partner with third-party service providers to enhance client experience.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>10.2</b> The Company is not responsible for any disruption, inaccuracies, or issues arising from third-party services.
                                </li>
                            </ol>
                        </li>

                        <li style={{ textAlign: "justify" }}><b>11. Limitation of Liability</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}>
                                    <b>11.1</b> The Company shall not be liable for any losses arising from market fluctuations, system failures, delays, or circumstances beyond its control.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>11.2</b> The Company shall not be responsible for decisions made by the Client based on market data or research provided.
                                </li>
                            </ol>
                        </li>

                        <li style={{ textAlign: "justify" }}><b>12. Governing Law & Jurisdiction</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}>
                                    <b>12.1</b> These Terms shall be governed by and construed in accordance with the laws of Bangladesh.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>12.2</b> Any disputes arising shall be subject to the jurisdiction of the courts of Bangladesh.
                                </li>
                            </ol>
                        </li>

                        <li style={{ textAlign: "justify" }}><b>13. Amendments</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}>
                                    <b>13.1</b> The Company reserves the right to amend these Terms at any time.
                                </li>
                                <li style={{ textAlign: "justify" }}>
                                    <b>13.2</b> Updated Terms shall be communicated to Clients and will become effective upon publication or notification.
                                </li>
                            </ol>
                        </li>

                        <li style={{ textAlign: "justify" }}><b>14. Acceptance</b>
                            <ol>
                                <li style={{ textAlign: "justify" }}>
                                    By using the services of <b>United Securities Limited</b>, the Client confirms acceptance of these Terms and Conditions.
                                </li>
                            </ol>
                        </li>

                    </ol>
                </div>
            </div>
        </section>
    </>
  )
}

export default TermsAndConditions
